var map = {
	"./amazon.png": 3421,
	"./amz-mobile.png": 1806,
	"./amz.png": 7845,
	"./drawings/Andrei.jpg": 648,
	"./drawings/City-on-the-hill.jpg": 328,
	"./drawings/Earth.jpg": 5549,
	"./drawings/Girl-with-butterflies.jpg": 5032,
	"./drawings/Grumpy-cat.jpg": 1098,
	"./drawings/IMG_8306.jpg": 1136,
	"./drawings/Iceberg.jpg": 366,
	"./drawings/Ilona.jpg": 7744,
	"./drawings/Ilonchuk.jpg": 7796,
	"./drawings/In-the-garden.jpg": 2590,
	"./drawings/Jessy1.jpg": 9550,
	"./drawings/Lianok.jpg": 3915,
	"./drawings/Milwaukee-1.jpg": 519,
	"./drawings/Moments.jpg": 2854,
	"./drawings/Mountain.jpg": 5296,
	"./drawings/Mushroom-Tree.jpg": 2662,
	"./drawings/Mushroom-town.jpg": 1398,
	"./drawings/Nest.jpg": 1667,
	"./drawings/Octo-Tree.jpg": 3343,
	"./drawings/Octopus.jpg": 3870,
	"./drawings/Piece-of-a-spoon.jpg": 4163,
	"./drawings/Piece-of-the-bow.jpg": 5764,
	"./drawings/Roksolana_maylar_ink.jpg": 7863,
	"./drawings/Ruins.jpg": 8676,
	"./drawings/Saturnity.jpg": 5666,
	"./drawings/ShellTown.jpg": 8383,
	"./drawings/Shellville.jpg": 8599,
	"./drawings/Sun.jpg": 2811,
	"./drawings/Sunflower.jpg": 8154,
	"./drawings/Train-Home.jpg": 8403,
	"./drawings/Tree2.jpg": 2987,
	"./drawings/Tree3.jpg": 4942,
	"./drawings/Tree_2.jpg": 8738,
	"./drawings/Turtle-Ville.jpg": 2832,
	"./drawings/UniCity.jpg": 5422,
	"./drawings/Up.jpg": 8054,
	"./drawings/Valera.jpg": 4376,
	"./drawings/atom.png": 1394,
	"./drawings/barn.png": 1386,
	"./drawings/birth.png": 562,
	"./drawings/cactus-house.jpg": 1771,
	"./drawings/fairytale.png": 4354,
	"./drawings/garden.png": 1930,
	"./drawings/girl.jpg": 7595,
	"./drawings/industrial.jpg": 5064,
	"./drawings/julianna.jpg": 9565,
	"./drawings/lighthouse.png": 5802,
	"./drawings/selfportrait.png": 162,
	"./drawings/vines.png": 2262,
	"./email.png": 2401,
	"./gallerievalerie.jpg": 9134,
	"./ig.png": 7565,
	"./illustrations/Burger-.jpg": 5521,
	"./illustrations/City-on-the-hill.jpg": 7196,
	"./illustrations/Flo-city.jpg": 2066,
	"./illustrations/Housing-projects.jpg": 4717,
	"./illustrations/Inula.jpg": 1426,
	"./illustrations/Lemur.jpg": 7530,
	"./illustrations/Llama.jpg": 6706,
	"./illustrations/MUFFIN.jpg": 1846,
	"./illustrations/Mushrooms.jpg": 8176,
	"./illustrations/Pattern.png": 4843,
	"./illustrations/Train1.jpg": 9014,
	"./illustrations/atom.jpg": 6194,
	"./illustrations/baloon1.jpg": 1685,
	"./illustrations/bee.jpg": 9345,
	"./illustrations/birds-view.png": 3179,
	"./illustrations/blackberry.jpg": 9266,
	"./illustrations/butterfly.jpg": 3488,
	"./illustrations/butterfly_kate.jpg": 9288,
	"./illustrations/camel.jpg": 3491,
	"./illustrations/cat.jpg": 8401,
	"./illustrations/chameleon.jpg": 8207,
	"./illustrations/cheetah.jpg": 1919,
	"./illustrations/cicada.jpg": 6348,
	"./illustrations/colibri.jpg": 6305,
	"./illustrations/crab.jpg": 5271,
	"./illustrations/cycle1.jpg": 6290,
	"./illustrations/deer.png": 6849,
	"./illustrations/dinosaur.jpg": 384,
	"./illustrations/dirigible.jpg": 3928,
	"./illustrations/dog.jpg": 9123,
	"./illustrations/fairy.jpg": 6710,
	"./illustrations/fish2.jpg": 3973,
	"./illustrations/fish_1.jpg": 6099,
	"./illustrations/fish_olenka.jpg": 7400,
	"./illustrations/flamingo.jpg": 3486,
	"./illustrations/goat.jpg": 1648,
	"./illustrations/gyraff2.jpg": 590,
	"./illustrations/heart3.jpg": 7914,
	"./illustrations/housegrowth.png": 800,
	"./illustrations/houseplant.png": 7414,
	"./illustrations/houses-wine.jpg": 6174,
	"./illustrations/houses-yard.jpg": 3017,
	"./illustrations/jellyfish.jpg": 8159,
	"./illustrations/ladybug.jpg": 5011,
	"./illustrations/manta.jpg": 1632,
	"./illustrations/octopus4.jpg": 2204,
	"./illustrations/orchid.jpg": 9412,
	"./illustrations/orchids.png": 4681,
	"./illustrations/parrot.jpg": 5769,
	"./illustrations/saturn1.jpg": 8111,
	"./illustrations/shell1.jpg": 8242,
	"./illustrations/shelville1.jpg": 994,
	"./illustrations/snaility1.jpg": 9787,
	"./illustrations/sunflower.jpg": 622,
	"./illustrations/townhouse_insta.jpg": 7062,
	"./illustrations/tucan.jpg": 9704,
	"./illustrations/turtle.jpg": 995,
	"./illustrations/turtle2.jpg": 6921,
	"./illustrations/watermelon.jpg": 1567,
	"./logo.png": 1212,
	"./logo_yy.png": 3647,
	"./octopus.png": 7710,
	"./paintings-ethno/Podilia.jpg": 5916,
	"./paintings-ethno/kharkiv.jpg": 3642,
	"./paintings-ethno/kurka.jpg": 7442,
	"./paintings-ethno/pattern.jpg": 6390,
	"./paintings-ethno/rooster.jpg": 7396,
	"./paintings-ethno/rooster1.jpg": 6675,
	"./paintings-ethno/rushnyk.jpg": 5120,
	"./paintings-ethno/vyshyvka.jpg": 4782,
	"./paintings/Abstract-Anomaly.jpg": 453,
	"./paintings/Chamille.jpg": 9950,
	"./paintings/Cicada.jpg": 9006,
	"./paintings/City-on-clouds.jpg": 3559,
	"./paintings/Dreamworld.jpg": 1440,
	"./paintings/Flamity.jpg": 5207,
	"./paintings/FullGlass.jpg": 1458,
	"./paintings/Glow.jpg": 5744,
	"./paintings/Grace.jpg": 5471,
	"./paintings/Greenhouse.jpg": 6884,
	"./paintings/Growth.jpg": 5358,
	"./paintings/Hope.jpg": 685,
	"./paintings/Master-copy-of-Louisa-Matthiasdottirs-work.jpg": 5530,
	"./paintings/MushTown.jpg": 1228,
	"./paintings/Octo.png": 7562,
	"./paintings/Podilia.jpg": 2779,
	"./paintings/Portrait-of-Roksolana.jpg": 3761,
	"./paintings/Saturn.jpg": 4006,
	"./paintings/Snaility.jpg": 3822,
	"./paintings/Sun-Earth.jpg": 3962,
	"./paintings/Tail.jpg": 9449,
	"./paintings/Travel.jpg": 9731,
	"./paintings/Tree1.jpg": 3010,
	"./paintings/TurtleVille.jpg": 6109,
	"./paintings/Up.jpg": 8292,
	"./paintings/WorldsEnergy.jpg": 5484,
	"./paintings/chicken.jpg": 3606,
	"./paintings/colibri.jpg": 7127,
	"./paintings/dou-color-Abstract.jpg": 9194,
	"./paintings/heart.jpg": 7387,
	"./paintings/kharkiv.jpg": 1325,
	"./paintings/kingsfisher.jpg": 3040,
	"./paintings/kurka.jpg": 3477,
	"./paintings/macaw.jpg": 9306,
	"./paintings/pattern.jpg": 9777,
	"./paintings/peacock.jpg": 137,
	"./paintings/rooster.jpg": 7999,
	"./paintings/rooster1.jpg": 6978,
	"./paintings/rushnyk.jpg": 1987,
	"./paintings/snowy_egret.jpg": 9949,
	"./paintings/stork.jpg": 3566,
	"./paintings/tucan.jpg": 9998,
	"./paintings/vyshyvka.jpg": 9976,
	"./photography/alcatraz.jpg": 4305,
	"./photography/chicago.jpg": 8385,
	"./photography/chicago_1.jpg": 6065,
	"./photography/chicago_4.jpg": 8528,
	"./photography/chicago_wheel.jpg": 7173,
	"./photography/dome.jpg": 7580,
	"./photography/fullton.png": 99,
	"./photography/fullton_up.png": 1027,
	"./photography/mohonk.jpg": 7739,
	"./photography/montreal.jpg": 7091,
	"./photography/norway-1.jpg": 173,
	"./photography/norway-5.jpg": 4593,
	"./photography/norway-7.jpg": 7875,
	"./photography/sanfran-1.jpg": 1280,
	"./photography/skeleton.png": 4136,
	"./photography/via.jpg": 7485,
	"./photography/whitney.jpg": 5807,
	"./portrait1.jpg": 7451,
	"./printmaking/3-color-experiment-1.jpg": 1353,
	"./printmaking/3-color-print1.jpg": 3416,
	"./printmaking/Birth2.jpg": 5287,
	"./printmaking/Cactus-house.jpg": 6962,
	"./printmaking/City-nests.jpg": 8363,
	"./printmaking/Energy.jpg": 7576,
	"./printmaking/Flight.jpg": 5798,
	"./printmaking/Ghost-print-of-the-Village.jpg": 6250,
	"./printmaking/Growing.jpg": 1825,
	"./printmaking/IMG_8576.jpg": 9622,
	"./printmaking/IMG_8578.jpg": 2120,
	"./printmaking/IMG_8582.jpg": 8503,
	"./printmaking/Jellytown2.jpg": 9042,
	"./printmaking/Light2.jpg": 1178,
	"./printmaking/Light_state22.jpg": 232,
	"./printmaking/Old-House.jpg": 9474,
	"./printmaking/Photo-print.jpg": 4184,
	"./printmaking/Shellville2.jpg": 3598,
	"./printmaking/Starry-night.jpg": 930,
	"./printmaking/Town-Nest.jpg": 7309,
	"./printmaking/Tree.jpg": 4608,
	"./printmaking/Turtle2.jpg": 3826,
	"./printmaking/Turtle_state12.jpg": 7221,
	"./printmaking/Underwworld2.jpg": 4667,
	"./printmaking/Village-in-the-mountains-.jpg": 2964,
	"./printmaking/city-series1.jpg": 1230,
	"./printmaking/explosion.jpg": 2035,
	"./printmaking/heart-attack1.jpg": 1384,
	"./printmaking/house-life1.jpg": 9710,
	"./printmaking/house-series1.jpg": 3185,
	"./printmaking/industrial-flower1.jpg": 1272,
	"./printmaking/industrialization1.jpg": 3468,
	"./printmaking/octopus3.jpg": 6322,
	"./sculptures/berry.png": 8148,
	"./sculptures/city.png": 4271,
	"./sculptures/face.png": 765,
	"./sculptures/plates.jpg": 5621,
	"./sculptures/vase.jpg": 6701,
	"./signature.svg": 67,
	"./studio.jpeg": 7980,
	"./yuliya_profile_gallery.jpg": 7245
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9265;